import { Form, Formik, FormikProps } from "formik";
import BreadCrum from "../../lib/BreadCrum";
import AddIcon from '@mui/icons-material/Add';
import { CommonLayout, ConfirmationDialog } from "../commonComponents";
import { Box, Button, CardMedia, Grid, IconButton, InputAdornment, Radio, Skeleton, Table, TableBody, TableContainer, TableHead, TableRow, TableCell, TextField, Theme, Typography, useTheme, FormControlLabel, Checkbox, Dialog, DialogContent, DialogActions, RadioGroup, Tooltip, MenuItem, Menu, ListItemButton, List, SelectChangeEvent } from "@mui/material";
import GroupIcon from "../../assets/icons/GroupIcon";
import { useHistory, useParams } from "react-router";
import { useEffect, useRef, useState } from "react";
import * as yup from 'yup';
import { MFSubmitButton, MFTextField } from "../../lib/formik";
import FormikSearchDropdown from "../../lib/formik/FormikSearchDropdown";
import { SubHeading } from "../investors/components";
import MFSelectField from "../../lib/formik/SelectField";
import { applicantStatusMasters, BseStartCreationOptions, ONBOARDING_TYPE_MAPPER, NOMINEE_DETAILS_NOMINEE_LIMIT, EITHER_OR_SURVIVOR } from "../../utils/constant";
import MFCheckbox from "../../lib/formik/Checkbox";
import { EditIcon, InfoIconOutlined } from "../../assets/SvgIcons";
import UseRadioGroup from "../../lib/formik/Radio";
import { stringRegex, } from "../../utils/regex";
import { getNomineeRelationship, isMinor, maxAge, removeSingleQuote } from "../../utils/utilityFunctions";
import { createJointHolderApplication, getIndividualApplication, getNomineeBankList } from "../../redux-store/actions/jointHolder";
import { showError } from "../../redux-store/actions/auth";
import { useDispatch } from "react-redux";
import { ApplicationProps, Bank, DataMaster, DataMasters, dataTypeMasters, NomineeType, VerifyPanResponseBody, VerifyPanRequestBody, SendEmailRequestBody, VerifyOtpResponseBody, FileType } from "../../redux-store/types/api-types";
import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";
import { getApplicationDetails, getDocuments, updateApplication } from "../../redux-store/actions/application";
import { getDataMasters, verifyPan } from "../../redux-store/actions/onBoarding";
import { saveApplication } from "../../redux-store/actions/jointHolder";
import { SaveApplicationRequestBody } from "../../redux-store/types/jointHolder";
import { AddNomineePopup } from "./jointHNomineePopup";
import { AddBankPopup } from "./jointHBankPopup";
import FreeTextPopup, { ManualJointHolder, JointHolderVerifyStatus } from "./jointHolFreeTextpopup/FreeTextPopup";
import DocumentUploadPopup from "./jointHNomineeDocumentPopup";
import { Dayjs } from "dayjs";
import { getFormattedISTDate } from "../../utils/date";



export interface initialValuesJointHolder {
  modeOfHolding: string;
  noOfJointHolders: number;
  primaryHolder: string;
  primaryHolderId: number;
  jointHolder1: string;
  jointHolder1Id: number;
  jointHolder2: string;
  jointHolder2Id: number;
  isBSEEnabled: boolean | null;
  nomineeDetails: updateNominee[];
  nomineesSOA: boolean | string | null;
  bankDetails: updatedBank[];
  documents: initialDocument[];
  doNotWishToNominate: boolean;
  isEitherOrSurvivor?: boolean;
}

export interface initialDocument {
  documentId: string;
  documentType: string;
  documentName: string;
  multipleFiles: string;
  required: string;
  options: string[];
  uploadFormats: string[];
  maxFiles: number;
  maxFileSize: string;
  minFileSize: string;
  disabled?: boolean;
  isActive: boolean;
  uniqueKey: string;
  id?: string | number;
  file?: FileType;
  loading?: boolean;
  expiryDate?: Dayjs | null;
  isThirdPartyFetched?: boolean | null;
  url?: string;
  [key: string]: string | number | boolean | FileType | undefined | string[] | null | boolean | Dayjs;
}

export type updateNominee = NomineeType & {
  Relationship: string | null;
  sno?: number;
};

export type updatedBank = Bank & {
  loading: boolean;
  bankAddress: string;
  isDefaultBank: boolean;
  sno: number;
  pennydropCheck: boolean;
  pennydropVerified: boolean;
  pennydropResponse: string;
};


export interface InvestorData {
  applicantId: number;
  applicationId: string;
  applicationNumber: string;
  modeOfHolding: string;
  name: string;
  panNo: string;
  isBSEEnabled?: boolean | null;
  onboardingType?: string;
  onboardingVia?: string;
  onboardingSubType?: string;
  onboardingApplicationType?: string;
  kycMethod?: string;
}

export interface GetInvestorNomineeBankData {
  primaryHolderId: number;
  thirdHolderId: number;
  secondHolderId: number;
  noOfJointHolders: number;
}

interface idState {
  id: string
}

const getMappedOnboardingApplicationType = (type?: string | null) => {
  if (!type) return undefined;
  const normalized = type.trim().replace(/[\s_-]/g, '').toLowerCase();
  if (!normalized) return undefined;

  if (normalized === 'nonindividual') {
    return ONBOARDING_TYPE_MAPPER.nonIndividual;
  }
  if (normalized === 'minor') {
    return ONBOARDING_TYPE_MAPPER.minor;
  }

  return ONBOARDING_TYPE_MAPPER.individual;
};




// for the main api to check if the relationship and percentage is entered
const nomineeSchema = yup.object().shape({
  nomineeRelationship: yup.string().when(['Relationship', 'isActive'], {
    is: (Relationship: string | null, isActive: boolean) =>
      isActive && `${Relationship ?? ''}`.toLowerCase() === 'others',
    then: yup
      .string()
      .matches(stringRegex, 'Special characters and numbers not allowed')
      .required('Please Specify Relationship'),
  }),
  Relationship: yup
    .string()
    .nullable()
    .when(['isActive'], {
      is: (isActive: boolean) => isActive,
      then: yup
        .string()
        .nullable()
        // .oneOf(NomineeRelations, 'Invalid value for Nominee Relationship')
        .required('Please select relationship'),
    }),
  nomineePercentage: yup.number().when('isActive', {
    is: true,
    then: yup.number().nullable().required('% is required').min(1, 'Value cannot be zero'),
    otherwise: yup.number().nullable().notRequired(),
  }),
});

const bankDetailSchema = yup.object().shape({
  bankName: yup.string().when('isActive', {
    is: true,
    then: schema => schema.required('Bank Name is Required'),
    otherwise: schema => schema.notRequired(),
  }),

  bankAccountNumber: yup.string().when('isActive', {
    is: true,
    then: schema => schema.required('Account Number is Required'),
    otherwise: schema => schema.notRequired(),
  }),

  bankBranch: yup.string().when('isActive', {
    is: true,
    then: schema => schema.required('Bank Branch is Required'),
    otherwise: schema => schema.notRequired(),
  }),
});

const validationSchema = yup.object({
  noOfJointHolders: yup.number().required('Joint Holder is Required'),
  primaryHolder: yup.string().required('Primary Holder is Required'),
  jointHolder1: yup.string().required('Joint Holder 1 is Required'),
  jointHolder2: yup.string().when('noOfJointHolders', {
    is: (noOfJointHolders: number) => noOfJointHolders === 2,
    then: yup.string().required('Joint Holder 2 is Required'),
    otherwise: yup.string().notRequired(),
  }),
  isBSEEnabled: yup.boolean().nullable().required('Bse Start UCC Creation is Required'),
  nomineeDetails: yup.array().of(nomineeSchema),
  bankDetails: yup.array().of(bankDetailSchema),
  nomineesSOA: yup.string().nullable().when('doNotWishToNominate', {
    is: false,
    then: schema => schema.oneOf(['true', 'false']).required('Nominees in SOA is Required'),
    otherwise: schema => schema.notRequired(),
  }),
  documents: yup.array().of(
    yup.object().shape({
      documentId: yup.string(),
      documentType: yup.string(),
    })
  )
});

const initialDoc: initialDocument[] = [
  // {
  //   documentId: "",
  //   documentType: "nominee_opt_out",
  //   documentName: "Nominee Opt Out Form Declaration",
  //   multipleFiles: "",
  //   required: 'false',
  //   options: [],
  //   uploadFormats: [
  //     "image/jpeg",
  //     "application/pdf",
  //     "image/png",
  //     "image/jpg"
  //   ],
  //   maxFiles: 1,
  //   maxFileSize: "2MB",
  //   minFileSize: "1KB",
  //   disabled: true,
  //   isActive: true,
  //   uniqueKey: '',
  //   url: ''
  // },
  {
    documentId: "",
    documentType: "bankAccountProof",
    documentName: "",
    multipleFiles: "",
    required: 'false',
    options: [],
    uploadFormats: [
      "image/jpeg",
      "application/pdf",
      "image/png",
      "image/jpg"
    ],
    maxFiles: 1,
    maxFileSize: "2MB",
    minFileSize: "1KB",
    disabled: true,
    isActive: false,
    uniqueKey: ''
  }
]
const initialValuesJointHolder = {
  modeOfHolding: 'joint',
  noOfJointHolders: 1,
  primaryHolder: '',
  primaryHolderId: 0,
  jointHolder1: '',
  jointHolder1Id: 0,
  jointHolder2: '',
  jointHolder2Id: 0,
  isBSEEnabled: null,
  nomineeDetails: [
  ],
  nomineesSOA: null,
  bankDetails: [
  ],
  documents: initialDoc,
  doNotWishToNominate: false,
  isEitherOrSurvivor: true,
};

const routerPath = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    warning: true
  },
  {
    name: 'Create Account',
    path: `/create-account`,
  },
]

function InvestorType({
  value,
  label,
  isDisabled,

}: { value: string; label: string; isDisabled: boolean; }) {

  const theme = useTheme()
  const disabledStyle = {
    borderWidth: "1px",
    borderColor: "primary.100",
    backgroundColor: "grey.50",
    cursor: 'not-allowed'
  }

  const styleObj: any = {
    currentStyle: null,
    fillColor: null,
    strokeColor: null,
    textColor: null
  }

  if (isDisabled) {
    styleObj.currentStyle = disabledStyle
    styleObj.fillColor = theme.palette.primary[200]
    styleObj.textColor = theme.palette.primary[200]
    styleObj.strokeColor = theme.palette.primary[200]
  }

  const iconsObj: Record<string, JSX.Element> = {
    accountType: <GroupIcon
      fillColor={styleObj.fillColor}
      strokeColor={styleObj.strokeColor}
    />,
  }
  return (
    <Box
      sx={{
        borderRadius: "15px",
        px: (value === "normal" ? "20px" : "33px"),
        py: ("26px"),
        borderStyle: "solid",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        rowGap: "5px",
        ...styleObj.currentStyle
      }}>
      {iconsObj[value]}
      <Typography variant='body_500' color={styleObj.textColor}>{label}</Typography>
    </ Box>
  )
}

function TableLoader({ row = 5, column = 8 }: { row: number; column: number }) {
  return (
    <>
      {[...Array(row)].map((_, rowIndex) => (
        <TableRow
          key={rowIndex}
          sx={{
            '& > *': { borderBottom: 'unset' },
            px: 0,
            my: 1,
            transition: 'all 0.3s ease-in-out',
          }}
        >
          {[...Array(column)].map((_, colIndex) => (
            <TableCell
              key={colIndex}
              sx={{
                px: 2,
                py: 1,
              }}
            >
              <Skeleton
                variant="rectangular"
                height={24}
                animation="wave"
                sx={{
                  borderRadius: 1,
                  bgcolor: 'grey.200',
                }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}


function JointHolder(): JSX.Element {
  const theme = useTheme();
  const history = useHistory();
  const state = history.location.state as idState;
  const { id } = state || {};

  const [investorData, setInvestorData] = useState<{
    primaryHolder: InvestorData[];
    jointHolder1: InvestorData[];
    jointHolder2: InvestorData[];
  }>({
    primaryHolder: [],
    jointHolder1: [],
    jointHolder2: []
  });
  const [openAddNomieePopup, setOpenAddNomieePopup] = useState<boolean>(false);
  const [openAddBankPopup, setOpenAddBankPopup] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<DataMaster>({});
  const [applicationsData, setApplicationsData] = useState<ApplicationProps[]>([]);
  const [primaryHolderApplicationId, setPrimaryHolderApplicationId] = useState<string>('');
  const formikRef = useRef<FormikProps<initialValuesJointHolder>>(null);
  const dispatch = useDispatch();
  const [idApplication, setIdApplication] = useState<ApplicationProps & { noOfApplicants: number; firstApplicantId: number; secondApplicantId: number; thirdApplicantId: number }>();
  const [nomineeBankLoading, setNomineeBankLoading] = useState<boolean>(false);
  const [nomineeEditIndex, setNomineeEditIndex] = useState<number>(-1);
  const [bankEditIndex, setBankEditIndex] = useState<number>(-1);
  const [isFieldDisabled, setFieldDisabled] = useState<boolean>(false);
  const [idNomineeData, setIdNomineeData] = useState<updateNominee[]>([]);
  const [idBankData, setIdBankData] = useState<updatedBank[]>([]);
  const [pennyDropStatusPopUp, setPennyDropStatusPopUp] = useState<boolean>(false);
  const [pennyDropMessage, setPennyDropMessage] = useState<string>('');
  const [nomineeOptOutDocumentPopup, setNomineeOptOutDocumentPopup] = useState<boolean>(false);
  // const [isNomineeBankApiCalled, setNomineeBankApiCalled] = useState(false);
  const [relationMaster, setRelationMaster] = useState<string[]>([])
  const [primaryHolderType, setPrimaryHolderType] = useState<string>('');
  const {
    noOfJointHolders,
    primaryHolderId,
    jointHolder1Id,
    jointHolder2Id,
    jointHolder1,
    jointHolder2,
  } = formikRef?.current?.values ?? {};
  const [applicantsPan, setApplicantsPan] = useState<string[]>([]);
  const [isAllBSEEnabled, setIsALLBSEEnabled] = useState<boolean>(true);
  const [documentsObj, setDocumentsObj] = useState<any>({});
  const [emailRelationOptions, setEmailRelationOptions] = useState<dataTypeMasters[]>([]);
  const [mobileRelationOptions, setMobileRelationOptions] = useState<dataTypeMasters[]>([]);
  const [manualPopupOpen, setManualPopupOpen] = useState<boolean>(false);
  const [manualPopupIndex, setManualPopupIndex] = useState<number>(0); // 0 for jointHolder1, 1 for jointHolder2
  const [manualJointHolder1Entries, setManualJointHolder1Entries] = useState<ManualJointHolder[]>([]);
  const [manualJointHolder2Entries, setManualJointHolder2Entries] = useState<ManualJointHolder[]>([]);
  const [manualHolderApplicationIds, setManualHolderApplicationIds] = useState<(string | number | null)[]>([null, null]);
  const [manualHolderApplicantIds, setManualHolderApplicantIds] = useState<{ secondApplicantId?: string | number | null; thirdApplicantId?: string | number | null }>({});
  const [primaryHolderApplication, setPrimaryHolderApplication] = useState<ApplicationProps | null>(null);
  const [selectedPrimaryHolderDetails, setSelectedPrimaryHolderDetails] = useState<InvestorData | null>(null);
  const [manualPopupSaveLoading, setManualPopupSaveLoading] = useState<boolean>(false);
  const [manualPopupMode, setManualPopupMode] = useState<'add' | 'view'>('add');
  const [isJhAccount, setIsJhAccount] = useState<boolean>(false);
  // const [pennyDropMessage, setPennyDropMessage] = useState<string>('');
  // Helper to get current manual entries based on index
  const getManualEntries = (index: number) => index === 0 ? manualJointHolder1Entries : manualJointHolder2Entries;
  const setManualEntries = (index: number, entries: ManualJointHolder[]) => {
    if (index === 0) {
      setManualJointHolder1Entries(entries);
    } else {
      setManualJointHolder2Entries(entries);
    }
  };

  const handleManualJointHolderUpdate = (entries: ManualJointHolder[], holderIndex: number) => {
    setManualEntries(holderIndex, entries);
    handleManualPopupClose();
  };

  const handleManualPopupClose = () => {
    setManualPopupOpen(false);
    setManualPopupSaveLoading(false);
    setManualPopupMode('add');
  };

  useEffect(() => { // data master api list call
    (async function () {
      try {
        const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
        setMdmsCountriesList(res?.data ?? {});
        setRelationMaster((res?.data?.RELATIONSHIP || []).map((item) => item?.description));
        setEmailRelationOptions(res?.data?.MAIL_ID_BELONGS_TO ?? []);
        setMobileRelationOptions(res?.data?.MOB_BELONGS_TO ?? []);

        const response = (await dispatch(getDocuments())) as unknown as any;
        const bankAccountProofDocument = response?.individual?.find((item: any) => item?.documentType === "bankAccountProof") || {};
        const nomineeOptOut = response?.individual?.find((item: any) => item?.documentType === "nominee_opt_out") || {};

        const bankObject = formikRef?.current && formikRef?.current?.values?.documents?.filter((item: any) => item?.documentType === "bankAccountProof") || [];
        // const nomineeObject = formikRef?.current && formikRef?.current?.values?.documents?.filter((item: any) => item?.documentType === "nominee_opt_out") || [];

        formikRef?.current?.setFieldValue('documents', [
          // ...nomineeObject.map((item: initialDocument) => ({
          //   ...item,
          //   options: [],
          //   uploadFormats: nomineeOptOut?.uploadFormats,
          //   maxFileSize: nomineeOptOut?.maxFileSize,
          //   minFileSize: nomineeOptOut?.minFileSize,
          //   disabled: true,
          //   documentName: nomineeOptOut?.documentName,
          //   maxFiles: nomineeOptOut?.maxFiles,
          //   url: nomineeOptOut?.url,
          //   required: nomineeOptOut?.required ?? false
          // })),
          ...bankObject.map((item: initialDocument) => ({
            ...item,
            options: bankAccountProofDocument?.options,
            uploadFormats: bankAccountProofDocument?.uploadFormats,
            maxFileSize: bankAccountProofDocument?.maxFileSize,
            minFileSize: bankAccountProofDocument?.minFileSize,
            disabled: false,
            documentName: '',
            maxFiles: bankAccountProofDocument?.maxFiles,
            required: bankAccountProofDocument?.required
          }))
        ]
        )
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  const {
    RELATIONSHIP = [],
  } = mdmsCountriesList || {};

  // Helper function to restore manual joint holders from existing application data
  const restoreManualJointHolders = (applicants: any[], secondApplicantId: number, thirdApplicantId: number) => {

    // Restore joint holder 1 if it was added manually
    const jh1Applicant = applicants.find((item) => item.id === secondApplicantId);

    // Check for multiple indicators of manual holder
    const isManualJH1 = jh1Applicant?.panVerificationToken ||
      jh1Applicant?.applicantVerificationToken ||
      (secondApplicantId === 0); // ID 0 indicates manual entry


    if (isManualJH1) {
      const manualJH1: ManualJointHolder = {
        fullName: String(jh1Applicant.name || ''),
        salutation: String(jh1Applicant.namePrefix || jh1Applicant.salutation || ''),
        pan: String(jh1Applicant.panNo || ''),
        dob: String(jh1Applicant.dob || ''),
        email: String(jh1Applicant.email || ''),
        mobile: String(jh1Applicant.mobile || ''),
        gender: String(jh1Applicant.gender || ''),
        placeOfBirth: String(jh1Applicant.placeOfBirth || ''),
        countryOfBirth: String(jh1Applicant.countryOfBirth || ''),
        grossAnnualIncome: String(jh1Applicant.grossAnnualIncome || ''),
        politicallyExposedPersonStatus: String(jh1Applicant.politicallyExposedPersonStatus || ''),
        countryCode: String(jh1Applicant.countryCode || '+91'),
        countryNameAndCode: String(jh1Applicant.countryNameAndCode || ''),
        emailPersonRelation: String(jh1Applicant.emailPersonRelation || false),
        emailDeclarationOther: String(jh1Applicant.emailDeclarationOther || ''),
        phonePersonRelation: String(jh1Applicant.phonePersonRelation || false),
        mobileDeclarationOther: String(jh1Applicant.mobileDeclarationOther || ''),
        panVerificationToken: String(jh1Applicant.panVerificationToken || ''),
        applicantVerificationToken: String(jh1Applicant.applicantVerificationToken || ''),
        panVerificationStatus: (jh1Applicant.panVerificationStatus as any) || '',
        taxResidentOfAnyCountryOtherThanIndia: jh1Applicant.taxResidentOfAnyCountryOtherThanIndia || false,
        taxCountryName: String(jh1Applicant.taxCountryName || ''),
        taxID: String(jh1Applicant.taxID || ''),
        idType: String(jh1Applicant.idType || ''),
      };
      setManualJointHolder1Entries([manualJH1]);
      setManualHolderApplicantIds(prev => ({
        ...prev,
        secondApplicantId: jh1Applicant.id
      }));
    }

    // Restore joint holder 2 if it was added manually
    const jh2Applicant = applicants.find((item) => item.id === thirdApplicantId);

    // Check for multiple indicators of manual holder
    const isManualJH2 = jh2Applicant?.panVerificationToken ||
      jh2Applicant?.applicantVerificationToken ||
      (thirdApplicantId === 0); // ID 0 indicates manual entry


    if (isManualJH2) {
      const manualJH2: ManualJointHolder = {
        fullName: String(jh2Applicant.name || ''),
        salutation: String(jh2Applicant.namePrefix || jh2Applicant.salutation || ''),
        pan: String(jh2Applicant.panNo || ''),
        dob: String(jh2Applicant.dob || ''),
        email: String(jh2Applicant.email || ''),
        gender: String(jh2Applicant.gender || ''),
        placeOfBirth: String(jh2Applicant.placeOfBirth || ''),
        countryOfBirth: String(jh2Applicant.countryOfBirth || ''),
        grossAnnualIncome: String(jh2Applicant.grossAnnualIncome || ''),
        politicallyExposedPersonStatus: String(jh2Applicant.politicallyExposedPersonStatus || ''),
        mobile: String(jh2Applicant.mobile || ''),
        countryCode: String(jh2Applicant.countryCode || '+91'),
        countryNameAndCode: String(jh2Applicant.countryNameAndCode || ''),
        emailPersonRelation: String(jh2Applicant.emailPersonRelation || false),
        emailDeclarationOther: String(jh2Applicant.emailDeclarationOther || ''),
        phonePersonRelation: String(jh2Applicant.phonePersonRelation || false),
        mobileDeclarationOther: String(jh2Applicant.mobileDeclarationOther || ''),
        panVerificationToken: String(jh2Applicant.panVerificationToken || ''),
        applicantVerificationToken: String(jh2Applicant.applicantVerificationToken || ''),
        panVerificationStatus: (jh2Applicant.panVerificationStatus as any) || '',
        taxResidentOfAnyCountryOtherThanIndia: jh2Applicant.taxResidentOfAnyCountryOtherThanIndia || false,
        taxCountryName: String(jh2Applicant.taxCountryName || ''),
        taxID: String(jh2Applicant.taxID || ''),
        idType: String(jh2Applicant.idType || ''),
      };
      setManualJointHolder2Entries([manualJH2]);
      setManualHolderApplicantIds(prev => ({
        ...prev,
        thirdApplicantId: jh2Applicant.id
      }));
    }

  };

  useEffect(() => { // Get the details of all the holders using the ID EDIT Option
    if (id === undefined) return;
    if (!formikRef.current) return;
    const { setValues } = formikRef.current;
    const fetchApplicationDetails = async () => {
      try {
        setLoading(true);
        const _application = await dispatch(getApplicationDetails(id)) as any as ApplicationProps & { noOfApplicants: number; firstApplicantId: number; secondApplicantId: number; thirdApplicantId: number; documents: any[] };
        if (!_application) return;
        const {
          modeOfHolding,
          noOfApplicants,
          applicants,
          nominees,
          banks,
          firstApplicantId,
          secondApplicantId,
          thirdApplicantId,
        } = _application || {};

        setIdApplication(_application);

        const updatedBanks = banks.map((item: any) => {
          return {
            ...item,
          }
        })
        const updatedNominees = nominees.map((nominee: any) => {
          return {
            ...nominee,
            nomineeName: nominee.nomineeName,
            guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
              ? nominee.guardianName
              : '',
            nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
              ? removeSingleQuote(nominee.nomineeGuardianPan)
              : null,
            Relationship: getNomineeRelationship(relationMaster, nominee.nomineeRelationship)
              ? nominee.nomineeRelationship ? nominee.nomineeRelationship : nominee.nomineeRelationship
              : 'Others',
            nomineeRelationship: getNomineeRelationship(relationMaster, nominee.nomineeRelationship)
              ? ''
              : nominee.nomineeRelationship,
            dateOfBirth: !nominee.dateOfBirth
              ? null
              : new Date(nominee.dateOfBirth).toISOString(),
          }
        })
        setValues({
          modeOfHolding,
          noOfJointHolders: (noOfApplicants - 1),
          primaryHolder: applicants.find((item: any) => item.id == firstApplicantId)?.name || '',
          primaryHolderId: firstApplicantId,
          //these is for displaying the JH1 search field inside name(pan)
          jointHolder1: (() => {
            const holder1 = applicants.find((item: any) => item.id == secondApplicantId);
            if (holder1 && holder1.panNo) {
              return `${holder1.name || ''} (${holder1.panNo})`;
            }
            return holder1?.name || '';
          })(),
          jointHolder1Id: secondApplicantId,
          jointHolder2: (() => {
            const holder2 = applicants.find((item: any) => item.id == thirdApplicantId);
            if (holder2 && holder2.panNo) {
              return `${holder2.name || ''} (${holder2.panNo})`;
            }
            return holder2?.name || '';
          })(),
          jointHolder2Id: thirdApplicantId,
          isBSEEnabled: _application.isBSEEnabled || null,
          nomineeDetails: updatedNominees,
          nomineesSOA: _application.nomineesSOA || null,
          bankDetails: updatedBanks,
          documents: formikRef.current?.values?.documents || [],
          doNotWishToNominate: _application?.doNotWishToNominate || false
        });
        setIdNomineeData(updatedNominees || []);
        setIdBankData(updatedBanks || []);
        setFieldDisabled(true);

        // Restore manual joint holders if they exist in the loaded application
        restoreManualJointHolders(applicants, secondApplicantId, thirdApplicantId);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchApplicationDetails();
  }, [id, dispatch, relationMaster]);

  useEffect(() => { // Get the details of all the nominees and banks with select
    if (idBankData.length > 0 || idNomineeData.length > 0) return;
    if (!formikRef.current) return;
    const { setFieldValue, values } = formikRef.current;
    const {
      noOfJointHolders,
      primaryHolderId,
      jointHolder1Id,
      jointHolder2Id,
      jointHolder1,
      jointHolder2,
    } = values

    const resolvedSecondHolderId = jointHolder1Id || manualHolderApplicantIds.secondApplicantId || 0;
    const resolvedThirdHolderId = jointHolder2Id || manualHolderApplicantIds.thirdApplicantId || 0;

    const hasManualJointHolder1 = manualJointHolder1Entries.some((entry) => !!entry.panVerificationToken);
    const hasManualJointHolder2 = manualJointHolder2Entries.some((entry) => !!entry.panVerificationToken);

    const hasFirstJointHolder =
      Boolean(resolvedSecondHolderId)
      || Boolean(jointHolder1)
      || hasManualJointHolder1;

    const requiresSecondHolder = Number(noOfJointHolders) > 1;
    const hasSecondJointHolder =
      !requiresSecondHolder
      || Boolean(resolvedThirdHolderId)
      || Boolean(jointHolder2)
      || hasManualJointHolder2;

    const hasRequiredJointHolderSelected =
      !!noOfJointHolders
      && !!primaryHolderId
      && hasFirstJointHolder
      && hasSecondJointHolder;

    if (hasRequiredJointHolderSelected) {
      const payload = {
        primaryHolderId: primaryHolderId,
        secondHolderId: Number(resolvedSecondHolderId) || 0,
        thirdHolderId: Number(resolvedThirdHolderId) || 0,
        noOfJointHolders: noOfJointHolders
      }
      const fetchData = async () => {
        try {
          setNomineeBankLoading(true);
          const result = await dispatch(getNomineeBankList(payload)) as unknown as ApplicationProps[];
          if (!result) {
            setNomineeBankLoading(false);
            return;
          }
          setApplicationsData(result);
          const primaryApplication = result?.find((item: any) => item?.firstApplicantId == primaryHolderId)
          if (primaryApplication) {
            setPrimaryHolderApplicationId(primaryApplication?.applicants?.[0]?.applicationId ?? '');
            setPrimaryHolderApplication(primaryApplication as ApplicationProps);
            let currentBankAccountType = ""

            if (
              (primaryApplication?.applicants?.[0]?.status ?? "" === applicantStatusMasters.NRE) ||
              (primaryApplication?.applicants?.[0]?.status ?? "" === applicantStatusMasters.NRO)
            ) {
              currentBankAccountType = primaryApplication?.applicants?.[0]?.status ?? ""
            }
            setPrimaryHolderType(currentBankAccountType);
          }

          const applicantsPan = result?.map((application: ApplicationProps) => application?.applicants?.map((applicant) => applicant.panNo) || []).flat() || [];
          setApplicantsPan((applicantsPan as string[]).filter((pan) => pan !== undefined) || []);

          const nominees = result?.map((item: any) => item.nominees);
          const flattenedNominees = nominees?.flat();
          const updatedNominees = flattenedNominees.length > 0 ? (flattenedNominees?.map((nominee: any, index) => ({
            ...nominee,
            isActive: false,
            Relationship: getNomineeRelationship(relationMaster, nominee.nomineeRelationship)
              ? nominee.nomineeRelationship
                ? nominee.nomineeRelationship
                : nominee.nomineeRelationship
              : 'Others',
            nomineeRelationship: getNomineeRelationship(relationMaster, nominee.nomineeRelationship)
              ? ''
              : nominee.nomineeRelationship,
            sno: index,
            nomineePercentage: nominee.nomineePercentage
              ? nominee.nomineePercentage
              : flattenedNominees.length == 1
                ? 100
                : 0,
          }))) : []
          setFieldValue('nomineeDetails', updatedNominees);
          const bankDetails = result?.map((item: any) => item?.banks ?? []);
          const flattenedBanks = bankDetails?.flat();
          const updatedBanks = flattenedBanks.length > 0 ? (flattenedBanks?.map((bank: any, index) => ({
            ...bank,
            // isActive: false,
            // defaultBankAccount: false,
            isDefaultBank: bank?.defaultBankAccount ?? false,
            sno: bank?.id ?? Date.now(),
          }))) : []
          setFieldValue('bankDetails', updatedBanks);

          setIsALLBSEEnabled(result.every((item) => item.isBSEEnabled));
          setFieldValue('isBSEEnabled', result.every((item) => item.isBSEEnabled).toString());
        }
        catch (error) {
          console.error((error as Error)?.message);
        } finally {
          setNomineeBankLoading(false);
        }
      };

      fetchData();
    }
  }, [
    noOfJointHolders,
    primaryHolderId,
    jointHolder1Id,
    jointHolder2Id,
    relationMaster,
    manualHolderApplicantIds,
    manualJointHolder1Entries,
    manualJointHolder2Entries,
  ]);

  const handleSubmit = async () => { // submit the details filled on the form Last Step/Api
    if (!formikRef.current) return;
    try {
      setLoading(true);
      const { values } = formikRef.current;
      const { nomineeDetails, bankDetails, isBSEEnabled, noOfJointHolders, primaryHolderId, jointHolder1Id, jointHolder2Id, documents, doNotWishToNominate, isEitherOrSurvivor } = values
      const filteredNominees = nomineeDetails
        ?.filter(nominee => !!nominee.isActive)
        ?.map(({ ...rest }) => rest);

      const filteredBankDetails = bankDetails
        ?.filter(bank => !!bank.isActive)
        ?.map(({ sno, ...rest }) => ({ ...rest }));

      // const nomineeOptOutDocument = documents.filter((doc) => doc.documentType === 'nominee_opt_out');
      const bankAccountProofDocument = documents.filter(doc => doc.documentType === 'bankAccountProof');

      if(!isEitherOrSurvivor && noOfJointHolders >= 2){
        dispatch(showError("Joint Holder Applications can have only one Joint Holder."))
      }

      // if (doNotWishToNominate) {
      //   if (!nomineeOptOutDocument?.[0]?.documentId) {
      //     dispatch(showError("Please upload nominee opt out document"));
      //     return;
      //   }
      // }
      if (!doNotWishToNominate && !filteredNominees.length) {
        dispatch(showError("Please select atleast one nominee"))
        return
      }
      if (!doNotWishToNominate && filteredNominees.length > NOMINEE_DETAILS_NOMINEE_LIMIT) {
        dispatch(showError(`Please select upto ${NOMINEE_DETAILS_NOMINEE_LIMIT} nominees`))
        return
      }
      if (!doNotWishToNominate && filteredNominees.map((nominee) => Number(nominee?.nomineePercentage)).reduce((a, b) => a + b, 0) != 100) {
        dispatch(showError("Nominee percentage should be equal to 100"))
        return
      }

      if (!doNotWishToNominate && filteredNominees.filter((nominee) => `${nominee.Relationship ?? ''}`.toLowerCase() === "mother").length > 1) {
        dispatch(showError("Mother Relationship cannot be more than one"));
        return;
      }
      if (!doNotWishToNominate && filteredNominees.filter((nominee) => `${nominee.Relationship ?? ''}`.toLowerCase() === "father").length > 1) {
        dispatch(showError("Father Relationship cannot be more than one"));
        return;
      }
      if (filteredNominees?.length > 1 && !doNotWishToNominate && filteredNominees?.some((nominee) => {
        const sameIdProof = filteredNominees.find((otherNominee) => {
          return otherNominee.idProofType === nominee.idProofType && otherNominee.idProofValue === nominee.idProofValue;
        });
        return sameIdProof && sameIdProof !== nominee;
      })) {
        dispatch(showError("Two Nominees cannot have same ID proof type and value"));
        return;
      }
      if (filteredNominees?.length > 1 && !doNotWishToNominate && filteredNominees.some((nominee) => `${nominee.idProofType ?? ''}`.toLowerCase() === 'pan' && applicantsPan.includes(nominee.idProofValue ?? ''))) {
        dispatch(showError("Nominee and Joint Holder Cannot be same"))
        return;
      }
      if (!filteredBankDetails.length) {
        dispatch(showError("Please select atleast one bank "))
        return
      }
      const defaultBanks = filteredBankDetails.filter(bank => bank.defaultBankAccount === true);
      if (defaultBanks.length > 1) {
        dispatch(showError("Please select only one default bank"))
        return;
      }
      if (!defaultBanks.length) {
        dispatch(showError("Please select atleast one default bank"))
        return;
      }

      if (bankDetails.some((bank) => bank.isActive && bank.defaultBankAccount && (!bank.pennydropVerified || ['NRE', 'NRO'].includes(bank.bankAccountType)))) {
        if ((!bankAccountProofDocument?.[0]?.documentId || !bankAccountProofDocument?.[0]?.documentName)) {
          if (!bankAccountProofDocument?.[0]?.documentId) {
            // dispatch(showError("Please upload default bank document proof"));
            dispatch(showError("Bank Account Proof Upload is mandatory in Document upload. Kindly upload to proceed."));
            return;
          }
          if (!bankAccountProofDocument?.[0]?.documentName) {
            // dispatch(showError("Please select default bank document type"));
            dispatch(showError("Bank Account Proof selection is mandatory in Document upload. Kindly choose an option from the dropdown to proceed."));
            return;
          }
        }
      }
      const updatedNominees = filteredNominees.map(({ Relationship, ...nominee }) => ({
        ...nominee,
        nomineeName: nominee.nomineeName,
        guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
          ? nominee.guardianName
          : '',
        nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
          ? removeSingleQuote(nominee.nomineeGuardianPan)
          : null,
        nomineeRelationship: getNomineeRelationship(relationMaster, Relationship)
          ? Relationship
          : removeSingleQuote(nominee.nomineeRelationship),
        dateOfBirth: !nominee.dateOfBirth
          ? null
          : new Date(nominee.dateOfBirth).toISOString(),
        countryCode: nominee.countryNameAndCode?.split(':')[1].trim(),
        otherCity: `${nominee.city ?? ''}`.toLowerCase() === 'others' ? nominee.otherCity : '',
        otherState: `${nominee.state ?? ''}`.toLowerCase() === 'others' ? nominee.otherState : '',
      }))
      let res;
      // const updatedDocuments = documents?.map(({ documentId, documentType, ...rest }) => ({ documentId, documentName: documentType }));
      const updatedDocuments = [
        ...(bankAccountProofDocument?.map(({ documentId, documentType, documentName, ...rest }: any) => ({ documentId, documentName, documentType })) || []),
        // ...(doNotWishToNominate ? nomineeOptOutDocument?.map(({ documentId, documentType, documentName, ...rest }: any) => ({ documentId, documentName, documentType })) || [] : []),
      ];
      const payload = {
        ...idApplication,
        nominees: updatedNominees,
        banks: filteredBankDetails,
        documents: updatedDocuments
      }
      if (id) {
        // Edit mode: Use clean applicant building logic
        const applicationId = id || manualHolderApplicationIds.find(appId => appId !== null) || null;  //handles both create and edit mode appilicationid

        // Get secondHolderId and thirdHolderId from stored applicant IDs (from saveApplication responses)
        const secondHolderId = idApplication?.secondApplicantId
          ? Number(idApplication.secondApplicantId)
          : (manualHolderApplicantIds.secondApplicantId
            ? Number(manualHolderApplicantIds.secondApplicantId)
            : (jointHolder1Id || 0));
        const thirdHolderId = idApplication?.thirdApplicantId
          ? Number(idApplication.thirdApplicantId)
          : (manualHolderApplicantIds.thirdApplicantId
            ? Number(manualHolderApplicantIds.thirdApplicantId)
            : (jointHolder2Id || 0));

        const applicantsPayload = [
          ...(idApplication?.applicants ?? []),
          ...(applicationsData?.map((data) => data.applicants ?? []).flat().filter(Boolean) ?? [])
        ];
        //  console.log("payload",applicantsPayload);

        // Helper to find an applicant from backend list by id
        const findApplicantById = (idToFind?: number | string | null) => {
          if (!idToFind) return undefined;
          return applicantsPayload.find((applicant: any) => Number(applicant?.id) === Number(idToFind));
        };

        // Build primary, joint holder 1 and joint holder 2 applicants explicitly
        // PRIMARY (index 0) - always from backend using primaryHolderId
        const primaryApplicant = findApplicantById(primaryHolderId);

        // JOINT HOLDER 1 (index 1)
        let jointHolder1Applicant: any = undefined;

        // If JH1 was saved manually, prefer manual data merged over backend object
        const hasManualJH1 = manualJointHolder1Entries.length > 0 &&
          (manualJointHolder1Entries[0].panVerificationToken ||
            (secondHolderId && manualHolderApplicantIds.secondApplicantId));

        // console.log('11. hasManualJH1:', hasManualJH1);
        // console.log('12. manualJointHolder1Entries:', manualJointHolder1Entries);

        const backendJH1Applicant = findApplicantById(secondHolderId);
        // console.log('13. backendJH1Applicant:', backendJH1Applicant);

        if (hasManualJH1) {
          const holder1 = manualJointHolder1Entries[0];
          // Start from backend applicant if available, so we retain backend fields
          jointHolder1Applicant = backendJH1Applicant ? { ...backendJH1Applicant } : {};

          const fullName = holder1.fullName?.trim() || '';

          jointHolder1Applicant = {
            ...jointHolder1Applicant,
            name: fullName,
            namePrefix: holder1.salutation,
            panNo: holder1.pan,
            dob: holder1.dob,
            email: holder1.email,
            mobile: holder1.mobile,
            countryCode: holder1.countryNameAndCode?.split(':')[1]?.trim() || '+91',
            countryNameAndCode: holder1.countryNameAndCode,
            emailPersonRelation: holder1.emailPersonRelation,
            emailDeclarationOther: holder1.emailDeclarationOther,
            phonePersonRelation: holder1.phonePersonRelation,
            mobileDeclarationOther: holder1.mobileDeclarationOther,
            panVerificationToken: holder1.panVerificationToken,
            applicantVerificationToken: holder1.applicantVerificationToken,
            panVerificationStatus: holder1.panVerificationStatus,
            gender: holder1.gender,
            placeOfBirth: holder1.placeOfBirth,
            countryOfBirth: holder1.countryOfBirth,
            grossAnnualIncome: holder1.grossAnnualIncome,
            politicallyExposedPersonStatus: holder1.politicallyExposedPersonStatus,
            taxResidentOfAnyCountryOtherThanIndia: holder1.taxResidentOfAnyCountryOtherThanIndia,
            taxCountryName: holder1.taxCountryName,
            taxID: holder1.taxID,
            idType: holder1.idType,
          };

          // Ensure id is set from stored applicant id if available
          if (manualHolderApplicantIds.secondApplicantId) {
            jointHolder1Applicant.id = manualHolderApplicantIds.secondApplicantId;
          } else if (!jointHolder1Applicant.id && backendJH1Applicant?.id) {
            jointHolder1Applicant.id = backendJH1Applicant.id;
          }
        } else {
          // No manual JH1, use backend applicant directly (search-based)
          jointHolder1Applicant = backendJH1Applicant;
        }

        // JOINT HOLDER 2 (index 2)
        let jointHolder2Applicant: any = undefined;

        // If JH2 was saved manually, prefer manual data merged over backend object
        const hasManualJH2 = manualJointHolder2Entries.length > 0 && manualJointHolder2Entries[0].panVerificationToken;
        const backendJH2Applicant = findApplicantById(thirdHolderId);

        if (hasManualJH2) {
          const holder2 = manualJointHolder2Entries[0];
          // Start from backend applicant if available, so we retain backend fields
          jointHolder2Applicant = backendJH2Applicant ? { ...backendJH2Applicant } : {};

          const fullName = holder2.fullName?.trim() || '';

          jointHolder2Applicant = {
            ...jointHolder2Applicant,
            // Manual holder now uses fullName + salutation only
            name: fullName,
            namePrefix: holder2.salutation,
            panNo: holder2.pan,
            dob: holder2.dob,
            email: holder2.email,
            mobile: holder2.mobile,
            countryCode: holder2.countryNameAndCode?.split(':')[1]?.trim() || '+91',
            countryNameAndCode: holder2.countryNameAndCode,
            emailPersonRelation: holder2.emailPersonRelation,
            emailDeclarationOther: holder2.emailDeclarationOther,
            phonePersonRelation: holder2.phonePersonRelation,
            mobileDeclarationOther: holder2.mobileDeclarationOther,
            panVerificationToken: holder2.panVerificationToken,
            applicantVerificationToken: holder2.applicantVerificationToken,
            panVerificationStatus: holder2.panVerificationStatus,
            gender: holder2.gender,
            placeOfBirth: holder2.placeOfBirth,
            countryOfBirth: holder2.countryOfBirth,
            grossAnnualIncome: holder2.grossAnnualIncome,
            politicallyExposedPersonStatus: holder2.politicallyExposedPersonStatus,
            taxResidentOfAnyCountryOtherThanIndia: holder2.taxResidentOfAnyCountryOtherThanIndia,
            taxCountryName: holder2.taxCountryName,
            taxID: holder2.taxID,
            idType: holder2.idType,
          };

          // Ensure id is set from stored applicant id if available
          if (manualHolderApplicantIds.thirdApplicantId) {
            jointHolder2Applicant.id = manualHolderApplicantIds.thirdApplicantId;
          } else if (!jointHolder2Applicant.id && backendJH2Applicant?.id) {
            jointHolder2Applicant.id = backendJH2Applicant.id;
          }
        } else {
          // No manual JH2, use backend applicant directly (search-based)
          jointHolder2Applicant = backendJH2Applicant;
        }

        // Final ordered applicants: [primary, JH1, JH2] without duplicates or empty slots
        const allApplicants = [primaryApplicant, jointHolder1Applicant, jointHolder2Applicant].filter(Boolean);

        // Add salutation to all applicants if missing
        allApplicants.forEach((applicant) => {
          if (applicant && !applicant.namePrefix && !applicant.salutation) {
            applicant.namePrefix = applicant.salutation || '';
          }
        });

        const payload = {
          noOfJointHolders,
          primaryHolderId, // From getNomineeBankList
          secondHolderId, // From saveApplication response (secondApplicantId)
          thirdHolderId, // From saveApplication response (thirdApplicantId)
          isBSEEnabled,
          nominees: updatedNominees,
          nomineesSOA: (filteredNominees.length == 0 || doNotWishToNominate) ? null : values?.nomineesSOA,
          banks: filteredBankDetails,
          documents: updatedDocuments,
          doNotWishToNominate,
          ...(applicationId && { applicationId }),
          // Add applicants array with ordered primary + joint holders
          ...(allApplicants.length > 0 && { applicants: allApplicants }),
        }
        res = await dispatch(createJointHolderApplication(payload));
      } else {
        const applicationId = manualHolderApplicationIds.find(id => id !== null) || null;

        // Get secondHolderId and thirdHolderId from stored applicant IDs (from saveApplication responses)
        // primaryHolderId comes from getNomineeBankList
        // secondHolderId comes from saveApplication response when joint holder 1 is saved (secondApplicantId)
        // thirdHolderId comes from saveApplication response when joint holder 2 is saved (thirdApplicantId)
        const secondHolderId = manualHolderApplicantIds.secondApplicantId
          ? Number(manualHolderApplicantIds.secondApplicantId)
          : (jointHolder1Id || 0);
        const thirdHolderId = manualHolderApplicantIds.thirdApplicantId
          ? Number(manualHolderApplicantIds.thirdApplicantId)
          : (jointHolder2Id || 0);

        const applicantsPayload = applicationsData?.map((data) => data.applicants ?? []).flat().filter(Boolean) ?? [];

        // Helper to find an applicant from backend list by id
        const findApplicantById = (idToFind?: number | string | null) => {
          if (!idToFind) return undefined;
          return applicantsPayload.find((applicant: any) => Number(applicant?.id) === Number(idToFind));
        };

        // Build primary, joint holder 1 and joint holder 2 applicants explicitly
        // PRIMARY (index 0) - always from backend using primaryHolderId
        const primaryApplicant = findApplicantById(primaryHolderId);

        // JOINT HOLDER 1 (index 1)
        let jointHolder1Applicant: any = undefined;

        // If JH1 was saved manually, prefer manual data merged over backend object
        const hasManualJH1 = manualJointHolder1Entries.length > 0 && manualJointHolder1Entries[0].panVerificationToken;
        const backendJH1Applicant = findApplicantById(secondHolderId);

        if (hasManualJH1) {
          const holder1 = manualJointHolder1Entries[0];
          // Start from backend applicant if available, so we retain backend fields
          jointHolder1Applicant = backendJH1Applicant ? { ...backendJH1Applicant } : {};

          const fullName = holder1.fullName?.trim() || '';
          //here the freetext field newly updated in fe wil store and hit final submit app api
          jointHolder1Applicant = {
            ...jointHolder1Applicant,
            name: fullName,
            namePrefix: holder1.salutation,
            panNo: holder1.pan,
            dob: holder1.dob,
            email: holder1.email,
            mobile: holder1.mobile,
            countryCode: holder1.countryNameAndCode?.split(':')[1]?.trim() || '+91',
            countryNameAndCode: holder1.countryNameAndCode,
            emailPersonRelation: holder1.emailPersonRelation,
            emailDeclarationOther: holder1.emailDeclarationOther,
            phonePersonRelation: holder1.phonePersonRelation,
            mobileDeclarationOther: holder1.mobileDeclarationOther,
            panVerificationToken: holder1.panVerificationToken,
            applicantVerificationToken: holder1.applicantVerificationToken,
            panVerificationStatus: holder1.panVerificationStatus,
            gender: holder1.gender,
            placeOfBirth: holder1.placeOfBirth,
            countryOfBirth: holder1.countryOfBirth,
            grossAnnualIncome: holder1.grossAnnualIncome,
            politicallyExposedPersonStatus: holder1.politicallyExposedPersonStatus,
            taxResidentOfAnyCountryOtherThanIndia: holder1.taxResidentOfAnyCountryOtherThanIndia,
            taxCountryName: holder1.taxCountryName,
            taxID: holder1.taxID,
            idType: holder1.idType,
          };

          // Ensure id is set from stored applicant id if available
          if (manualHolderApplicantIds.secondApplicantId) {
            jointHolder1Applicant.id = manualHolderApplicantIds.secondApplicantId;
          } else if (!jointHolder1Applicant.id && backendJH1Applicant?.id) {
            jointHolder1Applicant.id = backendJH1Applicant.id;
          }
        } else {
          // No manual JH1, use backend applicant directly (search-based)
          jointHolder1Applicant = backendJH1Applicant;
        }

        // JOINT HOLDER 2 (index 2)
        let jointHolder2Applicant: any = undefined;
        const hasManualJH2 = manualJointHolder2Entries.length > 0 && manualJointHolder2Entries[0].panVerificationToken;
        const backendJH2Applicant = findApplicantById(thirdHolderId);

        if (hasManualJH2) {
          const holder2 = manualJointHolder2Entries[0];
          // Start from backend applicant if available
          jointHolder2Applicant = backendJH2Applicant ? { ...backendJH2Applicant } : {};

          const fullName = holder2.fullName?.trim() || '';

          jointHolder2Applicant = {
            ...jointHolder2Applicant,
            // Manual holder now uses fullName + salutation only
            name: fullName,
            namePrefix: holder2.salutation,
            panNo: holder2.pan,
            dob: holder2.dob,
            email: holder2.email,
            mobile: holder2.mobile,
            countryCode: holder2.countryNameAndCode?.split(':')[1]?.trim() || '+91',
            countryNameAndCode: holder2.countryNameAndCode,
            emailPersonRelation: holder2.emailPersonRelation,
            emailDeclarationOther: holder2.emailDeclarationOther,
            phonePersonRelation: holder2.phonePersonRelation,
            mobileDeclarationOther: holder2.mobileDeclarationOther,
            panVerificationToken: holder2.panVerificationToken,
            applicantVerificationToken: holder2.applicantVerificationToken,
            panVerificationStatus: holder2.panVerificationStatus,
            gender: holder2.gender,
            placeOfBirth: holder2.placeOfBirth,
            countryOfBirth: holder2.countryOfBirth,
            grossAnnualIncome: holder2.grossAnnualIncome,
            politicallyExposedPersonStatus: holder2.politicallyExposedPersonStatus,
            taxResidentOfAnyCountryOtherThanIndia: holder2.taxResidentOfAnyCountryOtherThanIndia,
            taxCountryName: holder2.taxCountryName,
            taxID: holder2.taxID,
            idType: holder2.idType,
          };

          // Ensure id is set from stored applicant id if available
          if (manualHolderApplicantIds.thirdApplicantId) {
            jointHolder2Applicant.id = manualHolderApplicantIds.thirdApplicantId;
          } else if (!jointHolder2Applicant.id && backendJH2Applicant?.id) {
            jointHolder2Applicant.id = backendJH2Applicant.id;
          }
        } else {
          // No manual JH2, use backend applicant directly (search-based)
          jointHolder2Applicant = backendJH2Applicant;
        }

        // Final ordered applicants: [primary, JH1, JH2] without duplicates or empty slots
        const allApplicants = [primaryApplicant, jointHolder1Applicant, jointHolder2Applicant].filter(Boolean);

        const payload = {
          noOfJointHolders,
          primaryHolderId, // From getNomineeBankList
          secondHolderId, // From saveApplication response (secondApplicantId)
          thirdHolderId, // From saveApplication response (thirdApplicantId)
          isBSEEnabled,
          nominees: updatedNominees,
          nomineesSOA: (filteredNominees.length == 0 || doNotWishToNominate) ? null : values?.nomineesSOA,
          banks: filteredBankDetails,
          documents: updatedDocuments,
          doNotWishToNominate,
          isEitherOrSurvivor,
          ...(applicationId && { applicationId }),
          // Add applicants array with ordered primary + joint holders
          ...(allApplicants.length > 0 && { applicants: allApplicants }),
          // documents: filteredBankDetails.some((bank) => bank.isDefaultBank && bank.defaultBankAccount)
          //   ? []
          //   : (updatedDocuments?.length > 0 && updatedDocuments?.[0]?.documentId && updatedDocuments?.[0]?.documentType)
          //     ? updatedDocuments
          //     : []
        }
        
        res = await dispatch(createJointHolderApplication(payload));
      }
      if (!res) return;
      history.replace('/account-status');
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }

  }

  const fetchInvestorData = async (searchInput: string, name?: string) => { // feth the holder names from api when min 2 length
    try {
      if (searchInput?.trim()?.length > 2) {
        const res = await dispatch(getIndividualApplication(searchInput?.trim())) as unknown as InvestorData[];
        setInvestorData((prevState) => ({
          ...prevState,
          [name as string]: res
        }));
      } else {
        setInvestorData((prevState) => ({
          ...prevState,
          [name as string]: []
        }));
      }
    } catch (error) {
      console.log((error as Error)?.message ?? "");
    }
  }

  const handleAddDefaultBank = (index: number, checked: boolean, setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
    const { bankDetails, documents } = formikRef.current?.values || {};
    bankDetails?.forEach((bank, i) => {
      if (i !== index) {
        setFieldValue(`bankDetails.${i}.defaultBankAccount`, false);
      }
    });

    setFieldValue(`bankDetails.${index}.defaultBankAccount`, checked);
    setFieldValue(`bankDetails.${index}.isActive`, true);
    // setFieldValue('documents.0.documentId', '');
    // setFieldValue('documents.0.documentType', '');
  }

  const handlePennyDropPopUpClose = () => {
    setPennyDropStatusPopUp(false);
  };


  //here it is for jh1 and jh2  via the save application api for form creation

  const handleManualJointHolderSave = async (entries: ManualJointHolder[], holderIndex: number) => {
    const updatedEntries = entries.map((holder) => ({ ...holder }));

    // Get current form values for holder IDs
    const currentValues = formikRef.current?.values;
    if (!currentValues) {
      dispatch(showError("Form values not available. Please try again."));
      return;
    }

    const { primaryHolderId: formPrimaryHolderId, jointHolder1Id, jointHolder2Id } = currentValues;

    try {
      setManualPopupSaveLoading(true);
      const basePrimaryHolderApplicantId =
        primaryHolderApplication?.applicants?.[0]?.id
        || selectedPrimaryHolderDetails?.applicantId
        || formPrimaryHolderId;

      if (!basePrimaryHolderApplicantId) {
        dispatch(showError("Primary holder ID not available. Please select a primary holder."));
        return;
      }

      // Use primaryHolderId from getNomineeBankList (form values) or selected primary holder
      const resolvedPrimaryHolderId = Number(formPrimaryHolderId || basePrimaryHolderApplicantId);

      for (let index = 0; index < updatedEntries.length; index++) {
        const holder = updatedEntries[index];
        if (!holder.panVerificationToken) continue;

        // Extract countryCode from countryNameAndCode
        const countryCode = holder.countryNameAndCode?.split(':')[1]?.trim() || "+91";
        const otherHolderIndex = holderIndex === 0 ? 1 : 0;
        const otherApplicationId = manualHolderApplicationIds[otherHolderIndex];

        // Get secondHolderId and thirdHolderId from stored applicant IDs (from previous saveApplication responses)
        // Read fresh values each time to ensure we have the latest stored values
        // primaryHolderId comes from getNomineeBankList (formPrimaryHolderId)
        // secondHolderId comes from saveApplication response when joint holder 1 is saved (secondApplicantId)
        // thirdHolderId comes from saveApplication response when joint holder 2 is saved (thirdApplicantId)
        // Note: We read these at the start, but they'll be 0 for the first call, then updated after the API response
        const currentApplicantIds = manualHolderApplicantIds;

        // For joint holder 2 manual entry, get secondHolderId from search selection if available
        // If joint holder 1 was selected from search, use jointHolder1Id instead of manual save response
        let secondHolderId = currentApplicantIds.secondApplicantId || 0;
        if (holderIndex === 1 && jointHolder1Id && jointHolder1Id !== 0) {
          // Joint holder 1 was selected from search, use search ID
          secondHolderId = Number(jointHolder1Id);
        }

        const thirdHolderId = currentApplicantIds.thirdApplicantId || 0;

        // Map fields to SaveApplicationRequestBody format
        const payload: SaveApplicationRequestBody = {
          // For manual holders we now use fullName + salutation; backend SaveApplicationRequestBody
          // still expects firstName/lastName, so we can send the full name as firstName and leave lastName empty
          // firstName: holder.fullName,
          // lastName: "",
          namePrefix: holder.salutation, // ✅ Add salutation to payload
          dob: getFormattedISTDate(holder.dob) ?? holder.dob,
          pan: holder.pan,
          email: holder.email,
          gender: holder.gender,
          placeOfBirth: holder.placeOfBirth,
          countryOfBirth: holder.countryOfBirth,
          grossAnnualIncome: holder.grossAnnualIncome,
          politicallyExposedPersonStatus: holder.politicallyExposedPersonStatus,
          mobile: holder.mobile,
          emailPersonRelation: holder.emailPersonRelation,
          phonePersonRelation: holder.phonePersonRelation,
          countryCode: countryCode,
          countryNameAndCode: holder.countryNameAndCode,
          panVerificationToken: holder.panVerificationToken,
          primaryHolderId: resolvedPrimaryHolderId, // From getNomineeBankList
          secondHolderId: secondHolderId, // From saveApplication response (secondApplicantId)
          thirdHolderId: thirdHolderId, // From saveApplication response (thirdApplicantId)
          kycMethod: selectedPrimaryHolderDetails?.kycMethod
            || primaryHolderApplication?.applicants?.[0]?.kycMethod
            || "",
          holderNo: holderIndex + 1, // 1 for joint holder 1 (holderIndex 0), 2 for joint holder 2 (holderIndex 1)
          taxResidentOfAnyCountryOtherThanIndia: holder.taxResidentOfAnyCountryOtherThanIndia,
          taxCountryName: holder.taxCountryName || undefined,
          taxID: holder.taxID || undefined,
          idType: holder.idType || undefined,
        };
        if (otherApplicationId) {
          payload.applicationId = otherApplicationId;
        } else if (holderIndex > 0) {
          // Fallback: if adding joint holder 2 and joint holder 1 has applicationId
          const previousApplicationId = manualHolderApplicationIds[holderIndex - 1];
          if (previousApplicationId) {
            payload.applicationId = previousApplicationId;
          }
        }

        // In edit mode application id from path route
        if (id && !payload.applicationId) {
          payload.applicationId = id;
        }

        const saveRes = await dispatch(saveApplication(payload)) as unknown as any;
        if (!saveRes || saveRes.isSuccess === false) {
          const errorMessage = (saveRes as any)?.message || "Failed to save joint holder. Please try again.";
          dispatch(showError(errorMessage));
          throw new Error(errorMessage);
        }// Store application ID - check multiple possible response structures
        const applicationId = saveRes?.application?.id || saveRes?.id || saveRes?.data?.application?.id || saveRes?.data?.id;
        if (applicationId) {
          setManualHolderApplicationIds((prev) => {
            const next = [...prev];
            next[holderIndex] = applicationId;
            return next;
          });
        }
        if (holderIndex === 0) {
          // Try multiple possible paths for secondApplicantId
          const secondApplicantId = saveRes?.secondApplicantId
            || saveRes?.data?.secondApplicantId
            || saveRes?.application?.secondApplicantId
            || saveRes?.body?.secondApplicantId
            || saveRes?.secondHolderId
            || saveRes?.applicants?.[1]?.id  // Check if in applicants array (index 1 for second holder)
            || saveRes?.data?.applicants?.[1]?.id
            || saveRes?.application?.applicants?.[1]?.id;

          if (secondApplicantId) {
            setManualHolderApplicantIds((prev) => ({
              ...prev,
              secondApplicantId: secondApplicantId,
            }));
          }
        } else if (holderIndex === 1) {
          // Try multiple possible paths for thirdApplicantId
          const thirdApplicantId = saveRes?.thirdApplicantId
            || saveRes?.data?.thirdApplicantId
            || saveRes?.application?.thirdApplicantId
            || saveRes?.body?.thirdApplicantId
            || saveRes?.thirdHolderId
            || saveRes?.applicants?.[2]?.id  // Check if in applicants array (index 2 for third holder)
            || saveRes?.data?.applicants?.[2]?.id
            || saveRes?.application?.applicants?.[2]?.id;

          if (thirdApplicantId) {
            setManualHolderApplicantIds((prev) => ({
              ...prev,
              thirdApplicantId: thirdApplicantId,
            }));
          } else {
            console.warn('thirdApplicantId not found in response. Full response:', JSON.stringify(saveRes, null, 2));
            console.warn('Response keys:', Object.keys(saveRes || {}));
          }
        }

        // Store response data if needed
        if (saveRes?.applicantVerificationToken) {
          updatedEntries[index] = {
            ...holder,
            applicantVerificationToken: saveRes.applicantVerificationToken,
          };
        } else {
          updatedEntries[index] = {
            ...holder,
            applicantVerificationToken: holder.applicantVerificationToken || "",
          };
        }
      }

      // Only close popup and update state if all operations succeeded
      setManualEntries(holderIndex, updatedEntries);
      handleManualPopupClose();

      // Update jointHolder field with "Name (PAN)" format if first entry exists and is verified
      if (updatedEntries.length > 0 && updatedEntries[0].panVerificationToken) {
        const firstHolder = updatedEntries[0];
        const fullName = firstHolder.fullName?.trim() || "";
        const formattedLabel = `${fullName} (${firstHolder.pan.toUpperCase()})`;

        if (formikRef.current) {
          const fieldName = holderIndex === 0 ? 'jointHolder1' : 'jointHolder2';
          const fieldIdName = holderIndex === 0 ? 'jointHolder1Id' : 'jointHolder2Id';
          formikRef.current.setValues({
            ...formikRef.current.values,
            [fieldName]: formattedLabel,
            [fieldIdName]: 0, // Clear ID since it's manual entry
          });
        }
      }
    } catch (error) {
      // Handle any unexpected errors
      const errorMessage = (error as any)?.message || "An error occurred while saving. Please try again.";
      dispatch(showError(errorMessage));
      // Keep popup open so user can fix and retry
    } finally {
      setManualPopupSaveLoading(false);
    }
  };

  const handleManualJointHolderVerifyPan = async (
    index: number,
    holderIndex: number,
    holder: ManualJointHolder
  ): Promise<{ token: string; status: JointHolderVerifyStatus } | undefined> => {
    try {
      const fullName = holder.fullName?.trim() || "";

      const onboardingDetails =
        selectedPrimaryHolderDetails
          ? {
            onboardingType: selectedPrimaryHolderDetails.onboardingType,
            onboardingVia: selectedPrimaryHolderDetails.onboardingVia,
            onboardingSubType: selectedPrimaryHolderDetails.onboardingSubType,
            isBSEEnabled: selectedPrimaryHolderDetails.isBSEEnabled,
            onboardingApplicationType: selectedPrimaryHolderDetails.onboardingApplicationType,
          }
          : primaryHolderApplication
            ? {
              onboardingType: primaryHolderApplication.onboardingType,
              onboardingVia: primaryHolderApplication.onboardingVia,
              onboardingSubType: primaryHolderApplication.onboardingSubType,
              isBSEEnabled: primaryHolderApplication.isBSEEnabled,
              onboardingApplicationType:
                (primaryHolderApplication as ApplicationProps & { onboardingApplicationType?: string })?.onboardingApplicationType ||
                primaryHolderApplication.applicationType,
            }
            : null;

      if (!onboardingDetails) {
        dispatch(showError("Primary holder details not available for PAN verification"));
        return;
      }

      const mappedOnboardingApplicationType = getMappedOnboardingApplicationType(onboardingDetails.onboardingApplicationType);

      const body: VerifyPanRequestBody = {
        pan: holder.pan,
        dob: getFormattedISTDate(holder.dob) ?? holder.dob,
        onboardingType: onboardingDetails.onboardingType || "normal",
        onboardingVia: onboardingDetails.onboardingVia || "digital",
        name: fullName,
        onboardingSubType: onboardingDetails.onboardingSubType || "Individual",
        isBSEEnabled: onboardingDetails.isBSEEnabled ?? undefined,
        onboardingApplicationType: mappedOnboardingApplicationType || ONBOARDING_TYPE_MAPPER.individual,
      };

      const response = await dispatch(verifyPan(body, false)) as unknown as VerifyPanResponseBody;
      if (!response?.panVerificationToken) return;

      return {
        token: response.panVerificationToken,
        status: {
          panAddharCheck: Boolean(response.panAddharCheck),
          kraCheck: Boolean(response.kraCheck),
          amlCheck: Boolean(response.amlCheck),
          ckycCheck: Boolean(response.isCkycAvailable),
        },
      };
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <BreadCrum array={routerPath} />
      </Box>
      <Box mb="25px" mt={2} sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'space-between' }}>
        <Typography variant='h1' color="text.primary">
          {id ? "Update Application" : "Create Account"}
        </Typography>
        {id && <Typography variant='h1' color="text.primary">Application Id: {idApplication?.applicationNumber}</Typography>}
      </Box>
      <Box
        sx={{
          p: "25px",
          bgcolor: "background.paper",
          boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
          borderRadius: '25px',
          minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
          display: "flex",
          alignItems: "stretch",
        }}>

        <Formik
          innerRef={formikRef}
          initialValues={initialValuesJointHolder}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}>
          {({ values, setFieldValue, setValues, errors }) => {
            const noNominee = values.nomineeDetails
              ?.filter(nominee => !!nominee.isActive)
              ?.map(({ ...rest }) => rest).length === 0;

            const hasManualJointHolder1 = (manualJointHolder1Entries.some((entry) => !!entry.panVerificationToken) || (id && applicationsData.find((item) => `${item.applicants[0].id}` == `${values.jointHolder1Id}`) && applicationsData.find((item) => `${item.applicants[0].id}` == `${values.jointHolder1Id}`)?.status !== 'completed')) ?? false;
            // const hasManualJointHolder2 = manualJointHolder2Entries.length > 0 ? (manualJointHolder2Entries.some((entry) => !!entry.panVerificationToken) || (id && applicationsData.find((item) => `${item.applicants[0].id}` == `${values.jointHolder2Id}`)?.status !== 'completed')) : false;
            const hasManualJointHolder2 = (manualJointHolder2Entries.some((entry) => !!entry.panVerificationToken) || (id && applicationsData.find((item) => `${item.applicants[0].id}` == `${values.jointHolder2Id}`) && applicationsData.find((item) => `${item.applicants[0].id}` == `${values.jointHolder2Id}`)?.status !== 'completed')) ?? false;
            const canEnableSecondHolderOption =
              Boolean(values.jointHolder1Id) ||
              Boolean(values.jointHolder1) ||
              hasManualJointHolder1;
            return (
              <Form style={{ width: '100%' }}>
                <Grid container sx={{ mt: 0, display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center' }}>
                  {/* main Section */}
                  <Grid item xs={12} sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, alignItems: 'flex-start', justifyContent: 'flex-start', gap: { xs: 2, lg: 3 }, width: '100%' }}>
                    {/* Holders Selection Section */}
                    <Grid
                      item
                      xs={12}
                      lg={6}
                      sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, border: `1px solid ${theme.palette.text.secondary}26`, borderRadius: "15px", p: "35px", width: '100%' }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant='body_500' color="text.secondary" sx={{ mb: 2 }}>Investor Type</Typography>
                          <Grid container mt={1}>
                            <InvestorType
                              value='accountType'
                              label='Joint Holder'
                              isDisabled={true}
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={4} sm={5}>
                          <UseRadioGroup
                            formLabel="Number of Joint Holders*"
                            name={`noOfJointHolders`}
                            items={[1, 2].map((item) => ({
                              label: item.toString(),
                              value: item,
                            }))}
                            onChange={(e) => {
                              setFieldValue('noOfJointHolders', Number(e.target.value));
                              if (Number(e.target.value) === 1) {
                                setFieldValue('jointHolder2', '');
                                setFieldValue('jointHolder2Id', '');
                              }
                              if (Number(e.target.value) === 2) {
                                setFieldValue('isEitherOrSurvivor', true);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={8} sm={7} />
                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                          <MFCheckbox
                            name='isEitherOrSurvivor'
                            label='Anyone Or Survivor'
                            disabled={values.noOfJointHolders === 2}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                setIsJhAccount(true);
                              } else {
                                setFieldValue('isEitherOrSurvivor', true);
                              }
                            }}
                          />
                          <Tooltip title={'Joint Holder Application can have only One Holder'} followCursor>
                            <Typography sx={{ display: 'flex', alignItems: 'center' }}> <InfoIconOutlined /></Typography>
                          </Tooltip>
                        </Grid>
                        <Grid item xs={12}>
                          <FormikSearchDropdown
                            name="primaryHolder"
                            label="Primary Holder"
                            options={investorData?.primaryHolder?.map((obj: InvestorData) => ({
                              ...obj,
                              label: `${obj?.name} (${obj?.panNo})`,
                              value: obj?.applicantId?.toString() ?? "",
                            })) ?? []}
                            fetchData={fetchInvestorData}
                            disabled={isFieldDisabled}
                            onChange={(selectedObj: Record<string, any>) => {
                              // setFieldValue('primaryHolder', selectedObj?.label);
                              // setFieldValue('primaryHolderId', selectedObj?.value);
                              const hasSelection = Boolean(selectedObj?.value);
                              setSelectedPrimaryHolderDetails(hasSelection ? selectedObj as InvestorData : null);
                              setApplicationsData([]);
                              setPrimaryHolderApplicationId('');
                              setPrimaryHolderApplication(null);
                              setManualHolderApplicantIds({});
                              setManualHolderApplicationIds([null, null]);
                              setValues({
                                ...values,
                                primaryHolder: selectedObj?.label,
                                primaryHolderId: selectedObj?.value,
                                nomineeDetails: [],
                                bankDetails: [],
                              })
                              setIdNomineeData([]);
                              setIdBankData([]);
                            }}
                            filterOptions={(x) => x}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          {hasManualJointHolder1 ? (
                            // Show MFTextField when manual holder exists
                            <MFTextField
                              name="jointHolder1"
                              label="Joint Holder 1(Manual)"
                              // value={values.jointHolder1 || ''}
                              disabled={isFieldDisabled}
                              editable={false}
                              sx={{
                                '& .MuiInputBase-input.Mui-disabled': {
                                  WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                                  color: 'text.primary'
                                }
                              }}
                            />
                          ) : (
                            // Show search field when no manual holder
                            <FormikSearchDropdown
                              name="jointHolder1"
                              label="Joint Holder 1"
                              options={investorData?.jointHolder1?.map((obj: InvestorData) => ({
                                ...obj,
                                label: `${obj?.name} (${obj?.panNo})`,
                                value: obj?.applicantId?.toString() ?? "",
                              })) ?? []}
                              fetchData={fetchInvestorData}
                              disabled={isFieldDisabled || (manualJointHolder1Entries.length > 0 && !!manualJointHolder1Entries[0].panVerificationToken)}
                              // showPopupIcon={!hasManualJointHolder1}
                              onChange={(selectedObj: Record<string, any>) => {
                                // setFieldValue('jointHolder1', selectedObj?.label);
                                // setFieldValue('jointHolder1Id', selectedObj?.value);
                                setValues({
                                  ...values,
                                  jointHolder1: selectedObj?.label,
                                  jointHolder1Id: selectedObj?.value,
                                  nomineeDetails: [],
                                  bankDetails: [],
                                })
                                setIdNomineeData([]);
                                setIdBankData([]);
                              }}
                              filterOptions={(x) => x}
                            />
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            variant="outlined"
                            sx={{ width: '100%', borderRadius: '8px', height: 48, color: 'primary.main' }}
                            onClick={() => {
                              setManualPopupMode(manualJointHolder1Entries.length ? 'view' : 'add');
                              setManualPopupIndex(0);
                              setManualPopupOpen(true);
                            }}
                            disabled={!!values.jointHolder1Id && values.jointHolder1Id !== 0}
                          >
                            <Typography variant="body_600">
                              {manualJointHolder1Entries.length ? 'View JointHolder 1 Details' : 'Add JointHolder 1 Manually'}
                            </Typography>
                          </Button>
                        </Grid>

                        {/* Always show Joint Holder 2 UI when user selects 2 holders */}
                        {values?.noOfJointHolders > 1 && <Grid item xs={12}>
                          {!canEnableSecondHolderOption && (
                            <Typography variant="body_500" color="error.main" sx={{ mb: 2 }}>
                              Please enter joint holder 1 first
                            </Typography>
                          )}
                          {hasManualJointHolder2 ? (
                            // Show MFTextField when manual holder exists
                            <MFTextField
                              name="jointHolder2"
                              label="Joint Holder 2 (Manual)"
                              // value={values.jointHolder2 || ''}
                              disabled={isFieldDisabled}
                              editable={false}
                              sx={{
                                '& .MuiInputBase-input.Mui-disabled': {
                                  WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                                  color: 'text.primary'
                                }
                              }}
                            />
                          ) : (
                            // Show search field when no manual holder
                            <FormikSearchDropdown
                              name="jointHolder2"
                              label="Joint Holder 2"
                              options={investorData?.jointHolder2?.map((obj: InvestorData) => ({
                                ...obj,
                                label: `${obj?.name} (${obj?.panNo})`,
                                value: obj?.applicantId?.toString() ?? "",
                              })) ?? []}
                              fetchData={fetchInvestorData}
                              disabled={
                                !canEnableSecondHolderOption ||
                                (manualJointHolder2Entries.length > 0 && !!manualJointHolder2Entries[0].panVerificationToken) ||
                                // Boolean(id && values.jointHolder2Id && values.jointHolder2Id !== 0) ||
                                //but here the issue the the check fails when user enter the jh2 in draft mode through search this will disable automatically user cant chnage and he can only chnage when reload only
                                Boolean(id && manualJointHolder2Entries.length > 0 && !!manualJointHolder2Entries[0].panVerificationToken) // Edit mode + manual JH2 exists
                              }
                              // showPopupIcon={!hasManualJointHolder2}
                              onChange={(selectedObj: Record<string, any>) => {
                                // setFieldValue('jointHolder2', selectedObj?.label);
                                // setFieldValue('jointHolder2Id', selectedObj?.value);
                                setValues({
                                  ...values,
                                  jointHolder2: selectedObj?.label,
                                  jointHolder2Id: selectedObj?.value,
                                  nomineeDetails: [],
                                  bankDetails: [],
                                })
                                setIdNomineeData([]);
                                setIdBankData([]);
                              }}
                              filterOptions={(x) => x}
                            />
                          )}
                        </Grid>}
                        {values?.noOfJointHolders > 1 && <Grid item xs={12}>
                          {/* {!canEnableSecondHolderOption && (
                            <Typography variant="body_500" color="error.main" sx={{ mb: 2 }}>
                              Please enter joint holder 1 first
                            </Typography>
                          )} */}
                          <Button
                            variant="outlined"
                            sx={{ width: '100%', borderRadius: '8px', height: 48, color: 'primary.main' }}
                            onClick={() => {
                              if (!canEnableSecondHolderOption) {
                                // Don't open popup if joint holder 1 is not entered
                                return;
                              }
                              setManualPopupMode(manualJointHolder2Entries.length ? 'view' : 'add');
                              setManualPopupIndex(1);
                              setManualPopupOpen(true);
                            }}
                            disabled={!!values.jointHolder2Id && values.jointHolder2Id !== 0 || (!canEnableSecondHolderOption && !loading)}
                          >
                            <Typography variant="body_600">
                              {manualJointHolder2Entries.length ? 'View JointHolder 2 Details' : 'Add JointHolder 2 Manually'}
                            </Typography>
                          </Button>

                        </Grid>}
                        <Grid item xs={6} sm={6}>
                          {/* <Typography variant='body_500' color="text.secondary" sx={{ mb: 2 }}>BSE Star UCC Creation*</Typography> */}
                          {/* <BseStartCreation /> */}
                          <UseRadioGroup
                            formLabel="BSE Star UCC Creation*"
                            name={`isBSEEnabled`}
                            defaultValue={isAllBSEEnabled.toString()}
                            items={Object.keys(BseStartCreationOptions).map((item) => ({
                              label: BseStartCreationOptions[item],
                              value: item,
                            }))}
                            disabled={!isAllBSEEnabled}
                          />
                          {!isAllBSEEnabled && <Typography variant='subtitle_600' color="text.secondary" sx={{ mt: 2, mb: 2, fontWeight: 400 }}>One or more holders has BSE Status Disabled</Typography>}
                        </Grid>
                        <Grid item xs={6} sm={6} />
                      </Grid>
                    </Grid>

                    {/* Nominees and Bank Selection */}
                    <Grid container item xs={12} lg={6} rowSpacing={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}>

                      {/* NOMINEE SECTION */}
                      <Grid item xs={12} sx={{ width: '100%' }}>
                        {/* Header */}
                        <Grid container alignItems="center" justifyContent="space-between" mb={2}>
                          <Typography variant='body_600' color="text.primary" sx={{ fontWeight: 700 }}>
                            Select Nominees
                          </Typography>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ height: 40, borderRadius: '4px' }}
                            onClick={() => (setOpenAddNomieePopup(true), setFieldValue('doNotWishToNominate', false))}
                            disabled={applicationsData.length === 0 && idNomineeData.length === 0}
                          >
                            <Typography variant="body_500">+ Add Nominees</Typography>
                          </Button>
                          <AddNomineePopup open={openAddNomieePopup} onClose={() => { setOpenAddNomieePopup(false); setNomineeEditIndex(-1) }} value={values} setFieldValue={setFieldValue} applications={applicationsData} index={nomineeEditIndex} mdmsCountriesList={mdmsCountriesList} />
                        </Grid>

                        {/* Subheading */}
                        <SubHeading
                          sx={{
                            letterSpacing: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}>
                          <Typography variant='body_600' sx={{ fontWeight: 700 }}>
                            Nominee Details
                          </Typography>
                          {/* {values?.doNotWishToNominate &&
                            (<Button
                              startIcon={<AddIcon />}
                              sx={{
                                p: 0,
                                color: theme.palette.warning[900]
                              }}
                              onClick={() => {
                                setNomineeOptOutDocumentPopup(true)
                              }}>
                              <Typography variant='subtitle_500' sx={{ color: theme.palette.warning[900] }}>
                                {values.documents.find((doc: any) => doc?.documentType === "nominee_opt_out")?.documentId ? 'View Nominee opt-out Document' : 'Upload Nominee opt-out Document'}
                              </Typography>
                            </Button>
                            )} */}
                        </SubHeading>
                        {/* we are checking bank as we want to know when api got called successfully can't use nominee as there may be cases where we dont have any nominees but atleast one bank would be there */}
                        {values.bankDetails.length > 0 && <MFCheckbox
                          name="doNotWishToNominate"
                          label="Do not wish to Nominate"
                          checked={values.doNotWishToNominate}
                          onChange={(e) => {
                            setValues({
                              ...values,
                              doNotWishToNominate: e.target.checked,
                              nomineeDetails: values.nomineeDetails.map((obj: any) => ({ ...obj, isActive: false })),
                              nomineesSOA: null,
                            })
                            // if (e.target.checked) {
                            //   setFieldValue('documents', [
                            //     ...values?.documents?.filter((doc: any) => doc?.documentType === "nominee_opt_out").map((doc: any) => ({ ...doc, documentId: '', disabled: false, required: true })),
                            //     ...values?.documents?.filter((doc: any) => doc?.documentType !== "nominee_opt_out"),
                            //   ]);
                            // } else {
                            //   setFieldValue('documents', [
                            //     ...values?.documents?.filter((doc: any) => doc?.documentType === "nominee_opt_out").map((doc: any) => ({ ...doc, documentId: '', disabled: true, required: false })),
                            //     ...values?.documents?.filter((doc: any) => doc?.documentType !== "nominee_opt_out"),
                            //   ])
                            // }
                          }}
                        />}


                        {/* Nominee Table */}
                        {!values.doNotWishToNominate &&
                          <>
                            <TableContainer sx={{ overflow: 'auto', minHeight: 200, maxHeight: 300 }}>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell padding="checkbox" sx={{ minWidth: 50, width: 50 }}>Select</TableCell>
                                    <TableCell align="left" sx={{ minWidth: 150, width: 150 }}>Nominee Name</TableCell>
                                    <TableCell align="left" sx={{ minWidth: 100, width: 100 }}>Id Proof Type</TableCell>
                                    <TableCell align="left" sx={{ minWidth: 100, width: 100 }}>Id Proof Value</TableCell>

                                    <TableCell align="center" sx={{ width: 150 }}>Nominee Relationship</TableCell>
                                    <TableCell align="center" sx={{ width: 80 }}>Nominee %</TableCell>
                                    <TableCell align="right" sx={{ width: 100 }}>Actions</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody sx={{ overflow: 'auto', minHeight: 200, maxHeight: 300 }}>
                                  {values?.nomineeDetails?.length === 0 && !nomineeBankLoading && (
                                    <TableRow>
                                      <TableCell colSpan={7} align="center">
                                        No data found
                                      </TableCell>
                                    </TableRow>
                                  )}
                                  {nomineeBankLoading ? <TableLoader row={3} column={7} /> : null}
                                  {!nomineeBankLoading && values?.nomineeDetails?.map((nominee: any, index: number) => (
                                    <TableRow key={index}>
                                      <TableCell sx={{ verticalAlign: 'center', textAlign: 'center' }}>
                                        <MFCheckbox
                                          name={`nomineeDetails[${index}].isActive`}
                                          size="small"
                                          checked={nominee?.isActive}
                                          onChange={(e) => {
                                            setFieldValue(`nomineeDetails.${index}.isActive`, e.target.checked);
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ verticalAlign: 'center', textAlign: 'left' }}>
                                        <Typography variant="body2" sx={{ width: 150 }}>{nominee.nomineeName}</Typography>
                                      </TableCell>
                                      <TableCell sx={{ verticalAlign: 'center', textAlign: 'left' }}>
                                        <Typography variant="body2" sx={{ width: 100 }}>{nominee.idProofType}</Typography>
                                      </TableCell>
                                      <TableCell sx={{ verticalAlign: 'center', textAlign: 'left' }}>
                                        <Typography variant="body2" sx={{ width: 100 }}>{nominee.idProofValue}</Typography>
                                      </TableCell>
                                      <TableCell sx={{ verticalAlign: 'center', textAlign: 'center' }}>
                                        <MFSelectField
                                          name={`nomineeDetails[${index}].Relationship`}
                                          items={RELATIONSHIP.map((relation: dataTypeMasters) => ({
                                            key: relation?.description,
                                            value: relation?.description,
                                          }))}
                                          sx={{ width: 150, alignSelf: 'center' }}
                                          isCapitalize
                                        />
                                        {
                                          `${nominee?.Relationship ?? ''}`.toLowerCase() === 'others' && (
                                            <MFTextField
                                              name={`nomineeDetails[${index}].nomineeRelationship`}
                                              sx={{ width: 150, mt: 1 }}
                                            />
                                          )
                                        }
                                      </TableCell>
                                      <TableCell sx={{ verticalAlign: 'center', textAlign: 'center' }}>
                                        <MFTextField
                                          name={`nomineeDetails[${index}].nomineePercentage`}
                                          sx={{ width: 80 }}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ verticalAlign: 'center', textAlign: 'right' }}>
                                        <IconButton
                                          onClick={() => {
                                            // setFieldValue(`nomineeDetails.${index}.isActive`, false);
                                            setNomineeEditIndex(index);
                                            setOpenAddNomieePopup(true);
                                          }}
                                          sx={{
                                            ':hover': {
                                              bgcolor: theme.palette.customColors.lightGreyBlue,
                                            },
                                          }}>
                                          <EditIcon style={{ fontSize: 8, color: 'primary.main' }} />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                            {/* {values?.nomineeDetails?.length !== 0 && !noNominee && !nomineeBankLoading && (
                              <MFCheckbox
                                name="nomineesSOA"
                                label="Display Nominees in SOA"
                                checked={values.nomineesSOA}
                              />)} */}
                            <Grid sx={{mt: 2 }}>
                              {values?.nomineeDetails?.length !== 0 && !noNominee && !nomineeBankLoading && (
                                <UseRadioGroup
                                  formLabel="Display Nominees in SOA*"
                                  name="nomineesSOA"
                                  items={[
                                    { label: 'Yes', value: "true" },
                                    { label: 'No', value: "false" },
                                  ]}
                                  value={values.nomineesSOA ?? ""} 
                                />
                              )}
                            </Grid>
                          </>
                        }
                      </Grid>
                      {/* BANK SECTION */}
                      <Grid item xs={12} sx={{ width: '100%' }}>
                        {/* Header */}
                        <Grid container alignItems="center" justifyContent="space-between" mb={2}>
                          <Typography variant='body_600' color="text.primary" sx={{ fontWeight: 700 }}>
                            Select Bank
                          </Typography>
                          <Button variant="contained" size="small" sx={{ height: 40, borderRadius: '4px' }} onClick={() => { setOpenAddBankPopup(true); setBankEditIndex(-1) }} disabled={applicationsData.length === 0 && idBankData.length == 0}>
                            <Typography variant="body_500">+ Add Banks</Typography>
                          </Button>

                          <AddBankPopup
                            open={openAddBankPopup}
                            onClose={() => setOpenAddBankPopup(false)}
                            value={values}
                            setFieldValue={setFieldValue}
                            index={bankEditIndex}
                            applicationId={primaryHolderApplicationId ?? ''}
                            primaryApplicantType={primaryHolderType}
                          />
                        </Grid>

                        {/* Subheading */}
                        <Grid item xs={12}>
                          <SubHeading
                            sx={{
                              letterSpacing: '0.02px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                            <Typography variant='body_600' sx={{ fontWeight: 700 }}>Bank Details</Typography>
                            {/* {
                            !(values.bankDetails.some((bank: any) => bank.isActive && bank.isDefaultBank && bank.defaultBankAccount)) &&
                            (
                              (values.bankDetails.some((bank: any) => bank.isActive && !bank.pennydropVerified && !bank.isDefaultBank && !bank.defaultBankAccount) &&
                                (values?.documents?.[0]?.documentId && values?.documents?.[0]?.documentType)) ?
                                (<Button
                                  sx={{
                                    p: 0,
                                    color: theme.palette.warning[900]
                                  }}
                                  onClick={() => setPennyDropDocumentPopUp(true)}>
                                  <Typography variant='subtitle_500' sx={{ color: theme.palette.warning[900] }}>
                                    {values?.documents?.length} Document Uploaded
                                  </Typography>
                                </Button>) :
                                (values?.bankDetails.some((bank: any) => bank.isActive && !bank.pennydropVerified && bank.defaultBankAccount && !bank.isDefaultBank) &&
                                  (
                                    <Button
                                      startIcon={<AddIcon />}
                                      sx={{
                                        p: 0,
                                        color: theme.palette.warning[900]
                                      }}
                                      onClick={() => setPennyDropDocumentPopUp(true)}>
                                      <Typography variant='subtitle_500' sx={{ color: theme.palette.warning[900] }}>
                                        Upload Document
                                      </Typography>
                                    </Button>
                                  )
                                )
                            )
                          } */}
                            {
                              (values.bankDetails.some((bank: any) => bank.isActive && (!bank.pennydropVerified || ['NRE', 'NRO'].includes(bank.bankAccountType)) && bank.defaultBankAccount)) &&
                              (<Button
                                startIcon={<AddIcon />}
                                sx={{
                                  p: 0,
                                  color: theme.palette.warning[900]
                                }}
                                onClick={() => {
                                  setNomineeOptOutDocumentPopup(true)
                                }}>
                                <Typography variant='subtitle_500' sx={{ color: theme.palette.warning[900] }}>
                                  {values.documents.find((doc: any) => doc.documentType === 'bankAccountProof')?.documentId ? 'Update/View Default Bank Document' : 'Upload Default Bank Document'}
                                </Typography>
                              </Button>)
                            }
                          </SubHeading>
                        </Grid>
                        {/* Bank Details Table */}
                        <Grid item xs={12}>
                          <TableContainer sx={{ overflow: 'auto', minHeight: 200, maxHeight: 300 }}>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell padding="checkbox">Select</TableCell>
                                  <TableCell align="left">Default</TableCell>
                                  <TableCell align="center" width={'100px'}>Holder Name</TableCell>
                                  <TableCell align="center" width={'100px'}>Bank Name</TableCell>
                                  <TableCell align="center" width={'100px'}>Account No</TableCell>
                                  <TableCell align="center" width={'100px'}>Bank Branch</TableCell>
                                  <TableCell align="center">Status</TableCell>
                                  <TableCell align="center">Action</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody sx={{ overflow: 'auto', minHeight: 200, maxHeight: 300 }}>

                                {values?.bankDetails?.length === 0 && !nomineeBankLoading && (
                                  <TableRow>
                                    <TableCell colSpan={8} align="center">
                                      No data found
                                    </TableCell>
                                  </TableRow>
                                )}

                                {nomineeBankLoading ? <TableLoader row={3} column={8} /> : null}
                                {!nomineeBankLoading && values?.bankDetails?.map((bank: any, index: number) => (
                                  <TableRow key={index} sx={{ height: 64 }}>
                                    <TableCell padding="checkbox">
                                      <MFCheckbox
                                        name={`bankDetails[${index}].isActive`}
                                        size="small"
                                        checked={bank?.isActive || bank?.defaultBankAccount}
                                        onChange={(e) => {
                                          if (bank?.defaultBankAccount && !e.target.checked) { setFieldValue(`bankDetails.${index}.defaultBankAccount`, false) }
                                          // if (!bank?.defaultBankAccount) { setFieldValue(`bankDetails.${index}.isActive`, e.target.checked) }
                                          setFieldValue(`bankDetails.${index}.isActive`, e.target.checked);
                                          if (bank.defaultBankAccount && !bank.pennydropVerified && e.target.checked == true) {
                                            setPennyDropStatusPopUp(true);
                                            setPennyDropMessage(bank.pennydropResponse);
                                          }
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell sx={{ verticalAlign: 'center', textAlign: 'center' }}>
                                      <MFCheckbox
                                        name={`bankDetails[${index}].defaultBankAccount`}
                                        size="small"
                                        icon={<RadioButtonUnchecked />}
                                        checkedIcon={<RadioButtonChecked />}
                                        checked={bank?.defaultBankAccount}
                                        onChange={(e) => {
                                          handleAddDefaultBank(index, e.target.checked, setFieldValue);
                                          if (bank.isActive && !bank.pennydropVerified && e.target.checked == true) {
                                            setPennyDropStatusPopUp(true);
                                            setPennyDropMessage(bank.pennydropResponse);
                                            setFieldValue('documents', [
                                              // ...values?.documents?.filter((doc: any) => doc?.documentType === "nominee_opt_out"),
                                              ...values?.documents?.filter((doc: any) => doc?.documentType === "bankAccountProof").map((doc: any) => ({ ...doc, documentId: '', required: true })),
                                            ])
                                          } else if (bank.isActive && !bank.pennydropVerified && e.target.checked == false) {
                                            setFieldValue('documents', [
                                              // ...values?.documents?.filter((doc: any) => doc?.documentType === "nominee_opt_out"),
                                              ...values?.documents?.filter((doc: any) => doc?.documentType === "bankAccountProof").map((doc: any) => ({ ...doc, documentId: '', required: false })),
                                            ])
                                          } else if (bank.isActive && bank.pennydropVerified && e.target.checked == true) {
                                            setFieldValue('documents', [
                                              // ...values?.documents?.filter((doc: any) => doc?.documentType === "nominee_opt_out"),
                                              ...values?.documents?.filter((doc: any) => doc?.documentType === "bankAccountProof").map((doc: any) => ({ ...doc, documentId: '', required: false })),
                                            ])
                                          }
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2" width={'100px'}>{bank.holderName ?? "-"}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2" width={'100px'}>{bank.bankName ?? "-"}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2" width={'100px'}>{bank.bankAccountNumber ?? "-"}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2" width={'100px'}>{bank.bankBranch ?? "-"}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2" sx={{ color: bank.pennydropVerified ? 'success.main' : 'error.main' }} fontWeight={700} >{bank.pennydropVerified ? "Verified" : "Failed"}</Typography>
                                    </TableCell>
                                    <TableCell sx={{ verticalAlign: 'center', textAlign: 'center' }}>
                                      <IconButton
                                        onClick={() => {
                                          // setFieldValue(`bankDetails.${index}.isActive`, false);
                                          setBankEditIndex(index);
                                          setOpenAddBankPopup(true);
                                        }}
                                        sx={{
                                          ':hover': {
                                            bgcolor: theme.palette.customColors.lightGreyBlue,
                                          },
                                        }}>
                                        <EditIcon style={{ fontSize: 8, color: 'primary.main' }} />
                                      </IconButton>
                                      {/* {bank.isActive && !bank.pennydropVerified && bank.defaultBankAccount &&
                                      <IconButton
                                        onClick={() => {
                                          setBankDocumentUploadIndex(index);
                                          setPennyDropDocumentPopUp(true);
                                        }}
                                        sx={{
                                          ':hover': {
                                            color: theme.palette.customColors.lightGreyBlue,
                                          },
                                        }}>
                                        <UploadIcon style={{ color: 'primary.main' }} />
                                      </IconButton>} */}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Submit Button */}
                  <Grid
                    item xs={12} lg={6} sx={{ width: '100%' }} >
                    <Box mt={{ xs: 2, lg: 3 }} mb={1}>
                      <MFSubmitButton label="Submit Application" disabled={false} loadingEnable={loading} />
                    </Box>
                  </Grid>
                </Grid >
                {/* Document Upload Dialog Start */}
                <DocumentUploadPopup
                  open={nomineeOptOutDocumentPopup}
                  onClose={() => setNomineeOptOutDocumentPopup(false)}

                />
                <FreeTextPopup
                  open={manualPopupOpen}
                  onClose={handleManualPopupClose}
                  onSave={(entries) => handleManualJointHolderSave(entries, manualPopupIndex)}
                  onUpdate={(entries) => handleManualJointHolderUpdate(entries, manualPopupIndex)}
                  initialValues={getManualEntries(manualPopupIndex)}
                  emailRelationOptions={emailRelationOptions}
                  mobileRelationOptions={mobileRelationOptions}
                  onVerifyPan={(index, holder) => handleManualJointHolderVerifyPan(index, manualPopupIndex, holder)}
                  isBSEEnabled={selectedPrimaryHolderDetails?.isBSEEnabled ?? primaryHolderApplication?.isBSEEnabled ?? false}
                  isSaving={manualPopupSaveLoading}
                  mode={manualPopupMode}
                  dataMasters={mdmsCountriesList}
                  dataMasterLoading={false}
                  onboardingSubType={selectedPrimaryHolderDetails?.onboardingSubType ?? primaryHolderApplication?.applicants?.[0]?.onboardingSubType ?? ''}
                />
                {/* Document Upload Dialog End */}
                <ConfirmationDialog
                  open={isJhAccount}
                  setOpen={() => setIsJhAccount(false)}
                  onSave={() => { setFieldValue('isEitherOrSurvivor', false); setIsJhAccount(false); }}
                  onCancel={() => setIsJhAccount(false)}
                  customWidth='730px'
                  primaryButtonText='Confirm'
                  secondaryButtonText='Cancel'
                  message={EITHER_OR_SURVIVOR}
                />
              </Form>
            );
          }}
        </Formik >
      </Box >
      <Dialog
        onClose={handlePennyDropPopUpClose}
        open={pennyDropStatusPopUp}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 400,
            p: { xs: 2, sm: '45px 40px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiButton-root': {
              minWidth: 100,
              fontSize: 16,
            },
          }}>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 500,
              color: '#337FC9',
              textAlign: 'center',
              mb: 5,
            }}>
            {pennyDropMessage ?? 'Please Uplaod Default Bank Document'}
          </Typography>
        </Box>
        <Box
          sx={{
            gap: 1.5,
            '.MuiButton-root': {
              minWidth: '100px',
            },
            textAlign: 'center',
          }}>
          <Button variant="contained" onClick={handlePennyDropPopUpClose} sx={{ color: 'common.white' }}>
            Ok
          </Button>
        </Box>
      </Dialog>
      {/* <Dialog
        onClose={handlePennyDropDocumentPopUpClose}
        open={pennyDropDocumentPopUp}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 400,
            p: { xs: 2, sm: '45px 40px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            '& .MuiButton-root': {
              minWidth: 100,
              fontSize: 16,
            },
          }}>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 500,
              color: '#337FC9',
              textAlign: 'center',
              mb: 5,
            }}>
            Please Upload the Default Bank Document
          </Typography>
        </Box>
        <Box
          sx={{
            gap: 1.5,
            '.MuiButton-root': {
              minWidth: '100px',
            },
            textAlign: 'center',
          }}>
          <Button variant="contained" onClick={handlePennyDropDocumentPopUpClose} sx={{ color: 'common.white' }}>
            Ok
          </Button>
        </Box>
      </Dialog> */}
    </>
  );
}

export default function CreateJointHolder(): JSX.Element {
  return (
    <CommonLayout>
      <JointHolder />
    </CommonLayout>
  );
}
